function LinkSkip() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A link is present which allows users to skip over navigation or other content.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>A link that provides functionality for the user to jump over navigation or other elements or jump to the main content of the page greatly assists keyboard users in navigating the web page.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure that the link is functioning properly and that the link text adequately describes the link functionality. If the skip link is hidden from sighted users, it should be made visible within the page when it has keyboard focus and must be accessible via the keyboard (do not use CSS display:none or visibility:hidden).</p>
    </blockquote>
  )
}

export default LinkSkip